export enum CgiProvider {
    BankId = 'bankid',
    Freja = 'freja'
}

export interface CgiInitRequest {
    provider: CgiProvider;
    isSign: boolean;
    signMessage?: string;
}

export interface CgiInitResponse {
    OrderRef: string;
    QrStartToken: string;
    RequestStartedMilliseconds: number;
    AutoStartToken: string;
}

export interface CgiCollectRequest {
    orderRef: string;
    qrStartToken: string;
    requestStartedMilliseconds: number;
    provider: CgiProvider;
    target: FormType;
}

export interface CgiCollectResponse {
    ProgressStatus: CgiProgressStatusType;
    QrCodeData?: string;
    Provider: string;
    AccessToken?: string;
}

export enum FormType
{
    ResumedMembership,
    PowerOfAttorney,
}

export enum CgiProgressStatusType {
    COMPLETE = 0,
    USER_SIGN = 1,
    OUTSTANDING_TRANSACTION = 2,
    NO_CLIENT = 3,
    USER_REQ = 4,
    STARTED = 5
}

export interface CgiPollerProps extends CgiCollectRequest {
    authenticationOption: CgiAuthenticationOption;
    autoStartToken: string;
    onSuccess: () => void;
    onReset: () => void;
}

export interface PollingConfig {
    collectRequest?: CgiCollectRequest;
    authenticationOption: CgiAuthenticationOption;
    autoStartToken?: string;
}

export type CgiAuthenticationType = 'same-device' | 'other-device';

export enum CgiAuthenticationOption {
    BankIdSameDevice = 'bankid-same-device',
    BankIdOtherDevice = 'bankid-other-device',
    FrejaSameDevice = 'freja-same-device',
    FrejaOtherDevice = 'freja-other-device',
}

